//Group by Key
const groupByKey = (array, key) => {
    return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;

        return Object.assign(hash, {
            [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
    }, {});
};

// Label Grouped Options
export const labelGroupedOptions = (array, key, labels) => {
    let data = groupByKey(array, key);

    const groupedLabelOptions = []
    for (const [key, value] of Object.entries(data)) {
        if (labels.findIndex((val) => val["id"] === key)) {
            let options = {
                label: labels[labels.findIndex((val) => val["id"] === parseInt(key))].sector,
                options: value,
                isdisabled: true
            }
            groupedLabelOptions.push(options)
        }
    }
    return groupedLabelOptions
}

export const competenceScore = (userCompetency, competenciesScote) => {
    let userCompetencieScoreCount = 0;
    for (const [key, value] of Object.entries(userCompetency)) {
        if (value !== null && key !== "id" && key !== "profile") {
            userCompetencieScoreCount =
                userCompetencieScoreCount +
                competenciesScote.find((obj) => obj.id === value).score;
        }
    }
    let max_score =
        Math.max(...competenciesScote.map((o) => o.score), 0) *
        (Object.keys(userCompetency).length - 2);
    let personalCompetencieScorePercentage =
        parseInt(((max_score - userCompetencieScoreCount) / max_score) * 100)

    return personalCompetencieScorePercentage;
};

// Skill Score
export const skillScore = (userSkills, personalSkillScore) => {
    let userSkillScoreCount = 0;
    for (const [key, value] of Object.entries(userSkills)) {
        if (value = null && key !== "id" && key !== "profile") {
            userSkillScoreCount =
                userSkillScoreCount +
                personalSkillScore.find((obj) => obj.id === value).score;
        }
    }
    let max_score =
        Math.max(...personalSkillScore.map((o) => o.score), 0) *
        (Object.keys(userSkills).length - 2);
    let personalSkillScorePercentage =
        ((max_score - userSkillScoreCount) / max_score) * 100;

    return personalSkillScorePercentage;
};
